<template>
  <div>
    <Breadcrumbs 
      :children="[
        {
          text: 'Configuraciones',
        }
      ]"/>
    
    <div class="card">
      <div class="card-body">
        <div class="row" style="padding:10px;">
          <div class="col-sm-12">

            <ul class="nav nav-tabs mb-3" id="pills-tab" role="tablist">
              <li class="nav-item" role="presentation">
                <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">Orden comercios</a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">Distancia/Rango</a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" id="pills-contact-tab" data-toggle="pill" href="#pills-contact" role="tab" aria-controls="pills-contact" aria-selected="false">Tasa/Fee</a>
              </li>
            </ul>
            <div class="tab-content" id="pills-tabContent">
              <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">

                <!-- ORDEN COMERCIOS -->
      
                <div class="row">
                  <div class="col-sm-6">
                    <h6>Orden por tipo de comercio</h6>
                    <small>(Arrastre para cambiar)</small>
                    <ul class="list-group" id="types-sortable">
                      <li
                        :data-id="item.id"
                        :data-name="item.name"
                        v-for="item in orderedCompanyTypes"
                        :key="item.id"
                        class="list-group-item ui-state-default pointer"
                      >{{ item.position }} - {{ item.name }}</li>
                    </ul>

                    <button
                      class="btn btn-primary"
                      :disabled="loading"
                      @click="updateTypesPosition()"
                    >Guardar cambios</button>
                  </div>
                  <div class="col-sm-6">
                    <h6>Orden de suplidores</h6>
                    <label>Tipo de suplidor</label>
                    <select v-model="type" class="form-control mb-2">
                      <option value>-Seleccione-</option>
                      <option v-for="t in companyTypes" :value="t.id" :key="t.id">{{ t.name }}</option>
                    </select>

                    <small v-show="supliersForSelectedType.length > 0">(Arrastre para cambiar)</small>
                    <ul class="list-group" id="supliers-sortable">
                      <li
                        :data-id="item.id"
                        :data-name="item.name"
                        v-for="item in supliersForSelectedType"
                        :key="item.id"
                        class="list-group-item ui-state-default pointer"
                      >{{ item.position }} - {{ item.name }}</li>
                    </ul>

                    <button
                      class="btn btn-primary"
                      :disabled="loading || supliersForSelectedType.length == 0"
                      @click="updateSupliersPosition()"
                    >Guardar cambios</button>
                  </div>
                </div>
    
              </div>
              <div class="tab-pane fade show" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">

                <!-- DISTANCIA RANGO -->

                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="limit_driver_to_search">Limite de busqueda de delivery (km)</label>
                      <input v-model="distance.limit_driver_to_search" type="number" name="limit_driver_to_search" id="limit_driver_to_search" class="form-control">
                    </div>
                    <div class="form-group">
                      <label for="limit_driver_to_search">Mensaje limite de busqueda</label>
                      <textarea v-model="distance.message" class="form-control" name="message" id="message" cols="30" rows="3"></textarea>
                    </div>
                    <div class="form-group">
                      <label for="company_range">Rango de busqueda de comercios (mt)</label>
                      <input v-model="distance.range" type="number" name="company_range" id="company_range" class="form-control">
                    </div>
                    <div class="form-group">
                      <label for="company_range_test">Rango de busqueda de comercios (mt) PRUEBAS</label>
                      <input v-model="distance.range_test" type="number" name="company_range_test" id="company_range_test" class="form-control">
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="exampleInputEmail1">Buscar driver disponible</label>
                      <br />
                      <label class="switch">
                        <input type="checkbox" v-model="distance.search_available_driver" />
                        <span class="slider"></span>
                      </label>
                    </div>  
                    <div class="form-group">
                      <label for="exampleInputEmail1">Buscar por rango</label>
                      <br />
                      <label class="switch">
                        <input type="checkbox" v-model="distance.search_by_range" />
                        <span class="slider"></span>
                      </label>
                    </div>  
                    <div class="form-group">
                      <label for="exampleInputEmail1">Validar area</label>
                      <br />
                      <label class="switch">
                        <input type="checkbox" v-model="distance.validate_area" />
                        <span class="slider"></span>
                      </label>
                    </div>  
                  </div>
                </div>

                <button :disabled="gettingDistanceConfig" @click="saveDistanceConfig" class="btn btn-primary">Guardar cambios</button>

              </div>
              <div class="tab-pane fade show" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">

                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="payment_of_services_convertion_rate">Tasa de cambio para pago de servicios</label>
                      <input v-model="payment_of_services_convertion_rate" type="number" name="payment_of_services_convertion_rate" id="payment_of_services_convertion_rate" class="form-control">
                    </div>
                    <div class="form-group">
                      <label for="service_fee">Cargo por servicio (%)</label>
                      <input v-model="service_fee" type="number" name="service_fee" id="service_fee" class="form-control">
                    </div>
                  </div>
                </div>

                <button :disabled="loading || gettingServiceFee" @click="saveServiceFee" class="btn btn-primary">Guardar cambios</button>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import firebase from "firebase/app";
import Breadcrumbs from "../components/Breadcrumbs";
import { CompanyService } from '../../services/CompanyService';
import { UtilsService } from '../../services/UtilsService';

export default {
  name: "Configuration",
  components: { Breadcrumbs },
  data: function () {
    return {
      type: "",
      companyTypes: [],
      orderedCompanyTypes: [],
      loading: false,
      supliersForSelectedType: [],
      companyService: new CompanyService(),
      utilService: new UtilsService(),
      distance: {
        limit_driver_to_search: '',
        message: '',
        range: '',
        range_test: '',
        search_available_driver: '',
        search_by_range: '',
        validate_area: '',
      },
      gettingDistanceConfig: false,
      service_fee: '',
      payment_of_services_convertion_rate: '',
      gettingServiceFee: false
    };
  },
  methods: {
    async saveServiceFee(){
      this.gettingServiceFee = true;
      const res = await this.utilService.saveConvertionRateServiceFee({
        service_fee: this.service_fee,
        payment_of_services_convertion_rate: this.payment_of_services_convertion_rate,
      });
      if(res.ok){
        this.$helpers.toast('Datos actualizados', 'success');
      }else{
        this.$helpers.message('Error', res.message, 'error');
      }
      this.gettingServiceFee = false;
    },
    async getServiceFee(){
      this.gettingServiceFee = true;
      const res = await this.utilService.getConvertionRateServiceFee();
      if(res.ok){
        this.service_fee = res.data.service_fee;
        this.payment_of_services_convertion_rate = res.data.payment_of_services_convertion_rate;
      }
      this.gettingServiceFee = false;
    },
    async updateTypesPosition() {
      this.loading = true;
      const self = this;
      const allUpdates = [];
      try {
        $("#types-sortable li").each(function (index) {
          const id = $(this).data("id");
          allUpdates.push(self.updateTypePosition(id, index));
          self.companyTypes.find((s) => s.id == id).position = index;
        });
        await Promise.all(allUpdates);
        this.$helpers.toast("Orden actualizado!");
      } catch (error) {
        console.log("err ", error);
        this.$helpers.toast("Error al actualizar", "error");
      } finally {
        this.loading = false;
      }
    },
    updateTypePosition(id, position) {
      return this.companyService.updateEstablishmentTypePosition(id, position);
    },
    async getSupliersForSelectedType() {
      this.supliersForSelectedType = [];
      if (this.type != "") {
        this.loading = true;
        const list = await firebase
          .firestore()
          .collection('BranchOffices')
          .where('type', '==', this.type)
          .get();
        const tempList = [];
        list.forEach((comp) => {
          const data = comp.data();
          tempList.push({
            id: comp.id,
            name: data.name,
            position: data.position || 0,
          });
        });
        this.supliersForSelectedType = tempList.sort(this.sortByPosition);
        this.loading = false;
        this.$nextTick(() => {
          $("#supliers-sortable").sortable();
          $("#supliers-sortable").disableSelection();
        });
      }
    },
    updateSuplierPosition(id, position) {
      return firebase.firestore().collection('BranchOffices').doc(id).update({
        position: position,
      });
    },
    async updateSupliersPosition() {
      this.loading = true;
      const self = this;
      const allUpdates = [];
      try {
        $("#supliers-sortable li").each(function (index) {
          const id = $(this).data("id");
          allUpdates.push(self.updateSuplierPosition(id, index));
          self.supliersForSelectedType.find((s) => s.id == id).position = index;
        });
        await Promise.all(allUpdates);
        this.$helpers.toast("Orden actualizado!");
      } catch (error) {
        console.log("err ", error);
        this.$helpers.toast("Error al actualizar", "error");
      } finally {
        this.loading = false;
      }
    },
    sortByPosition(a, b) {
      if (a.position > b.position) {
        return 1;
      } else if (a.position < b.position) {
        return -1;
      } else {
        return 0;
      }
    },
    async getDistanceConfig(){
      this.gettingDistanceConfig = true;
      const res = await this.utilService.getDistanceConfig();
      if(res.ok){
        this.distance = Object.assign({}, res.data);
      }
      this.gettingDistanceConfig = false;
    },
    async saveDistanceConfig(){
      const res = await this.utilService.saveDistanceConfig(this.distance);
      if(res.ok){
        this.$helpers.toast('Datos actualizados', 'success');
      }else{
        this.$helpers.message('Error', res.message, 'error');
      }
    }
  },
  watch: {
    type(val) {
      this.getSupliersForSelectedType();
    },
  },
  async beforeMount(){
    this.getDistanceConfig();
    this.getServiceFee();
  },
  async mounted() {
    this.companyTypes = await this.companyService.getEstablishmentTypes();
    this.orderedCompanyTypes = this.companyTypes.sort(this.sortByPosition);
    this.$nextTick(() => {
      $("#types-sortable").sortable();
      $("#types-sortable").disableSelection();
    });
  },
};
</script>
<style scoped>
.twrap {
  max-height: 300px;
  overflow-y: auto;
}
* {
  font-weight: unset;
}
.pointer {
  cursor: pointer;
}
</style>
